export const intlSorter = Intl.Collator('ja-jp', { numeric: true }).compare

export function sortedIndex(seq, comparer) {
  return seq
    .map((x, i) => [x, i])
    .sort(comparer)
    .map((x) => x[1])
}
